
import { updateDurationLabel as updateDiagramDurationLabel, getDurationLabel as getDiagramDurationLabel } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    duration?: string;
}

export const changeDurationLabel = ({ duration }: Props) => {
    updateDiagramDurationLabel({ duration });
}

export const getDurationLabel = () => getDiagramDurationLabel();
